export default __webpack_public_path__ + "static/f5-46aed2dfd5e80760e262a69132499004.jpg";